<template>
  <div class="cert-badge" :class="statusClass" :title="label">
    <i :class="iconClass"></i>
    <span v-if="!$screen.mobile" class="label">{{ label }}</span>
  </div>
</template>

<script>
const STATUS = {
  Current: { className: 'current', icon: 'el-icon-check', label: 'OK' },
  ExpiringSoon: { className: 'expiring', icon: 'el-icon-warning-outline', label: 'Expiring soon' },
  Expired: { className: 'expired', icon: 'el-icon-close', label: 'Expired' },
  NeverCertified: { className: 'never', icon: 'el-icon-question', label: 'Never certified' }
}

// The API serializes the GasQualityStatus enum as its underlying integer
// (Newtonsoft default with no StringEnumConverter). Accept both shapes.
const NUMERIC_TO_NAME = {
  0: 'NeverCertified',
  1: 'Current',
  2: 'ExpiringSoon',
  3: 'Expired'
}

function normalizeStatus (value) {
  if (typeof value === 'number') return NUMERIC_TO_NAME[value] || 'NeverCertified'
  if (typeof value === 'string') {
    if (STATUS[value]) return value
    const asNum = Number(value)
    if (!Number.isNaN(asNum) && NUMERIC_TO_NAME[asNum]) return NUMERIC_TO_NAME[asNum]
  }
  return 'NeverCertified'
}

export default {
  name: 'CertificationStatusBadge',
  props: {
    status: {
      type: [String, Number],
      required: true
    }
  },
  computed: {
    descriptor () {
      return STATUS[normalizeStatus(this.status)]
    },
    statusClass () {
      return this.descriptor.className
    },
    iconClass () {
      return this.descriptor.icon
    },
    label () {
      return this.descriptor.label
    }
  }
}
</script>

<style lang="scss" scoped>
  .cert-badge {
    display: inline-flex;
    align-items: center;
    border: 1px solid;
    border-radius: 4px;
    padding: 6px 10px;
    font-size: 12px;
    font-weight: 500;
    line-height: 1;

    i {
      font-size: 14px;
    }

    .label {
      margin-left: 6px;
    }

    &.current {
      border-color: #53D788;
      color: #53D788;
    }

    &.expiring {
      border-color: #F8C764;
      color: #F8C764;
    }

    &.expired {
      border-color: #FD6F71;
      color: #FD6F71;
    }

    &.never {
      border-color: #C0C4CC;
      color: #909399;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/stations/station/Certification/CertificationStatusBadge.vue